/**
 * skills_summary is a Record<skillType, "held/total"> plus a "Total" aggregate. The
 * per-type count chips are driven off whatever skill types the payload actually
 * contains — the backend's _VALID_SKILL_TYPES is the single source of truth, so adding
 * a type server-side surfaces a chip here with no frontend change (provided a matching
 * CSS variant exists). "Total" is rendered separately as the lead text, so it's excluded.
 *
 * @param {Record<string, string>} summary
 * @returns {string[]} the skill-type keys, in payload order
 */
export function summaryTypeKeys(summary) {
  return Object.keys(summary ?? {}).filter(k => k !== 'Total')
}
